import importComponent from '../helpers/bootstrap';
import Component from 'component';
import _template from 'lodash/template';
import modalTpl from '../templates/modal';
import {
  KEYCODES
} from '../constants';


class Modal extends Component {
  constructor(el) {
    super(el);

    this.initType(el).then(modal => {
      this.modal = modal;
    });
  }
  setupDefaults() {
    this.dom = {
      lastFocusedElement: '',
      modalFirstElement: '',
      modalLastElement: ''
    };
  }

  initType($target) {
    switch ($target.data('modalType')) {

    case 'video':
      return importComponent('VideoModal', this.$el)
        .then(data => {
          if (!data) return;
          const {
            component,
            el
          } = data;
          return new component(el);
        });
      break;
    case 'review':
      return importComponent('ReviewModal', this.$el)
        .then(data => {
          if (!data) return;
          const {
            component,
            el
          } = data;
          return new component(el);
        });
      break;

    default:
      return Promise.resolve(this);
      break;
    }
  }

  addListeners() {
    this.$el.on('click', ::this.onOpenModal);
  }

  onOpenModal(e) {
    e.stopPropagation();
    e.preventDefault();
    this.openModal().catch(e => console.error(e));
  }

  onCloseModal(e) {
    e.stopPropagation();
    e.preventDefault();
    this.closeModal(e.target);
  }

  getContent() {
    //This is just placeholder content. It should actually never be displayed.
    this.content = {
      content: '<p>Content goes here</p>'
    }
    return this.content;
  }

  prepareModal(modalContent) {

    if (typeof modalContent === 'undefined') {
      modalContent = {
        content: ''
      }
    }

    //create function
    const templateFn = _template(modalTpl);

    //get placeholder
    const $placeholder = $('body');

    //execute template function with data
    const modalContentHTML = templateFn(modalContent);

    //put HTML in placeholder
    Promise.resolve($placeholder.append(modalContentHTML)).then(() => {
      //Run content initialization code
      if (typeof this.modal.initModalContent === 'function') {
        this.modal.initModalContent();
      }
    });

  }

  async openModal() {
    $('#modal').remove();
    const modal = await this.prepareModal(this.modal.getContent());
    this.showModal();

    if (typeof this.modal.onModalShow === 'function') {
      this.modal.onModalShow();
    }
  }

  showModal() {
    //Capture Focus
    this.dom.lastFocusedElement = document.activeElement;

    //Process document
    $('body').css('top', - $(window).scrollTop());
    $('body').addClass('modal-open');

    //show Modal
    $('#modal').fadeIn();

    //Save reference to modal content
    this.dom.$modalContent = $('#modal').find('.modal__inner');

    //focus on modal
    this.trapFocus(this.dom.$modalContent);

    //Close btn Listener
    $('#modal').on('click touchstart', '.btn-close--modal', ::this.onCloseModal);
  }

  trapFocus($element) {
    const $focusableElms = $element.find('a, object, :input, iframe, [tabindex]');
    this.dom.modalFirstElement = $focusableElms.first()[0];
    this.dom.modalLastElement = $focusableElms.last()[0];

    //Set focus inside modal content
    this.dom.modalFirstElement.focus();

    //Trap focus
    $element.on('keydown', e => {
      if (e.key === 'Tab' || e.keyCode === KEYCODES.tab) {
        if (e.shiftKey) /* shift + tab */ {
          if (document.activeElement === this.dom.modalFirstElement) {
            this.dom.modalLastElement.focus();
            e.preventDefault();
          }
        } else /* tab */ {
          if (document.activeElement === this.dom.modalLastElement) {
            this.dom.modalFirstElement.focus();
            e.preventDefault();
          }
        }
      }
    });

  }

  closeModal(trigger) {

    //Process document
    Promise.resolve($('body').removeClass('modal-open')).then(() => {
      if (this.dom.lastFocusedElement !== '') {
        //Return Focus
        $(this.dom.lastFocusedElement).focus();
      }
    });

    //close and remove Modal
    const $modalToClose = $(trigger).closest('.modal');
    $modalToClose.fadeOut({
      done: () => {
        $('#modal').remove();
      }
    });
    $('body').css('top', '');

  }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/btu/js/components/Modal.js